import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import before from '../../img/before.svg';
import Big3Common from "../../js/Big3Common";
/* 개발담당:양유빈
 * 화면기능:서브 헤더 공통
 * 아이콘: 뒤로가기, 헤더타이이틀, 삭제(휴기통)
 * Property: 
 *      링크방식: LinkUrl, ComponentUrl, HistoryBack, LinkUrl, ComponentUrl, HistoryBack중 하나만 사용 가능
 *      LinkUrl: 링크주소 라우팅, LinkUrl="/Home"
 *      ComponentUrl: 컴포넌트 라우팅,  ComponentUrl="ComponentName", 
 *      HistoryBack: HistoryBack=true
 *      HeaderTitle: 헤더 이름,  HeaderTitle="명칭"
 *      IConClassName: 오른쪽에 보여지는 추가기능 아이콘 IConClassName="delete" or hide or write
 *      ComponentName: Big3Common.Authentication에서 세션 체크위한 속성
*/
export class HeaderSub extends Component {
    static displayName = HeaderSub.name;
        
    constructor(props) {
        super(props);
        this.state = {
        };
        //Authentication 설정하지 않거나, 처리하지 않는다고 명시 할때만
        Big3Common.Authentication(this);
                
    }   
    //초기화
    componentDidMount() {
    }
    PageLink() {

        if (this.props.LinkUrl !== undefined) {
            return (
                <Link to={this.props.LinkUrl} >
                  <img src={before} alt="이전화면" />
                </Link>
            )
        }
        else if (this.props.HistoryBack !== undefined && this.props.HistoryBack === true) {
            return (
                <div className="before pointer">
                    <Link to={-1} >
                        <img src={before} alt="이전화면" />
                    </Link>
                </div>
            )
        }
        else {
            if (this.props.ComponentUrl !== undefined && this.props.ContentState === undefined) {
                return (
                    <div onClick={() => this.props.RenderComponent(this.props.ComponentUrl)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                );
            }
            else if (this.props.ComponentUrl !== undefined && this.props.ContentState !== undefined) {
                //이전 부모 화면에서 전체 state값을 가져오고 다시 돌려 줌. 상태유지가 필요할때
                return (
                    <div onClick={() => this.props.RenderComponent(this.props.ComponentUrl, this.props.ContentState)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                );
            } 
            
        }
    }
    PageAddFunc() {
        if (this.props.IConClassName === undefined || this.props.IConClassName === "hide") {
            return (
                <div className="hide"></div>
            )
        }
        else {
            return (
                <div className={this.props.IConClassName} onClick={this.props.IConClick} ></div>
            )
        }
        
    }
    render() {
        
        return (
            <header>
                <div className="nav">
                    <div className="before">
                        {this.PageLink()}
                    </div>
                    <div className="page_title">
                        {this.props.HeaderTitle}
                    </div>
                        {this.PageAddFunc() }
                </div>
            </header>
        );
    }
}
